import { render, staticRenderFns } from "./Search-brick.vue?vue&type=template&id=1452b02c&scoped=true&"
import script from "./Search-brick.vue?vue&type=script&lang=js&"
export * from "./Search-brick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1452b02c",
  null
  
)

export default component.exports